import { render, staticRenderFns } from "./ChooseAreaTags.vue?vue&type=template&id=e7e4eb3c&scoped=true&"
import script from "./ChooseAreaTags.vue?vue&type=script&lang=js&"
export * from "./ChooseAreaTags.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAreaTags.vue?vue&type=style&index=0&id=e7e4eb3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e4eb3c",
  null
  
)

export default component.exports